/** ============================================================= *
 *  ---------------------- IMPORT - START ----------------------- *
 *  ============================================================= */


import 'what-input'
import jQuery from 'jquery'
import Foundation from 'foundation-sites'
import intlTelInput from 'intl-tel-input'
import 'owl.carousel' // Import Owl Carousel JavaScript
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import { setHrefs } from './functions/data-hrefs'
import { initEqualizeContent } from './functions/equalizer'
import { initTelephoneInput } from './functions/intl-tel-input'
import { initDatepickerInput } from './functions/datepicker'
import { enableNegativeMargins } from './functions/negative-margins'
import { mapStyles } from './functions/map-styles'
// import { enableCallrailTracking } from './functions/callrail'
/** ============================================================= *
 *  ----------------------- IMPORT - END ------------------------ *
 *  ============================================================= */



/** ============================================================= *
 *  ------------ GLOBAL VARIABLES DECLARATION - START ----------- *
 *  ============================================================= */
const THEME_FOLDER = "../wp-content/themes/dolcan_homes_v2"
const PHONE_FIELD = ".codesm-phone-field"
const DATEPICKER_FIELD = ".codesm-datepicker-field"
const DATEPICKER_FORMAT = "mm/dd/yyyy"
const EQUALIZE_CONTENT = ".codesm-equalize-content"

Foundation.addToJquery(jQuery)
Swiper.use([Navigation, Pagination])
window.intlTelInput = intlTelInput
window.setHrefs = setHrefs
window.initEqualizeContent = initEqualizeContent
window.initTelephoneInput = initTelephoneInput
window.initDatepickerInput = initDatepickerInput
window.enableNegativeMargins = enableNegativeMargins
window.mapStyles = mapStyles
// window.enableCallrailTracking = enableCallrailTracking
/** ============================================================= *
 *  ------------- GLOBAL VARIABLES DECLARATION - END ------------ *
 *  ============================================================= */



jQuery(document).ready(function(){
	jQuery(document).foundation();
	triggerThemeFunctions();


	// ADD YOUR CODE HERE
	// 
	//

	var communitiesSwiper = new Swiper('#communities.swiper-container',{
		slidesPerView: 1,
		spaceBetween: 20,
		watchOverflow: true,
		navigation: {
			nextEl: '#communities-navigation .custom-next',
			prevEl: '#communities-navigation .custom-prev',
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			1440: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1200: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
			640: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
			0: {
				slidesPerView: 1,
				spaceBetween: 20,
			}
		},
		on: {
			'init': function() {
				new Foundation.Equalizer(jQuery("#communities.swiper-container")).applyHeight();
			},
		},
	});

	// FEATURED-PROPERTY SWIPER
	var featuredPropertiesSwiper = new Swiper('#featured-properties.swiper-container',{
		slidesPerView: 1,
		spaceBetween: 20,
		watchOverflow: true,
		navigation: {
			nextEl: '#featured-properties-navigation .custom-next',
			prevEl: '#featured-properties-navigation .custom-prev',
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 20,
			}
		},
		on: {
			'init': function() {
				new Foundation.Equalizer(jQuery("#featured-properties.swiper-container")).applyHeight();
			},
		},
	});

		// TESTIMONIALS SWIPER
		var testimonialSwiper = new Swiper('#testimonials.swiper-container',{
			slidesPerView: 1,
			spaceBetween: 20,
			watchOverflow: true,
			navigation: {
				nextEl: '#testimonials-navigation .custom-next',
				prevEl: '#testimonials-navigation .custom-prev',
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			breakpoints: {
				640: {
					slidesPerView: 1,
					spaceBetween: 20,
				}
			},
			on: {
				'init': function() {
					new Foundation.Equalizer(jQuery("#testimonials.swiper-container")).applyHeight();
				},
			},
		});	


	// Enable Negative Margins
	// jQuery(window).bind("resize", function () {
	// 	enableNegativeMargin();
	// });
	// enableNegativeMargin();


	// // jQuery Magnify
	// var $zoom = jQuery('.zoom');
	// $zoom.magnify();
	// var enabled = true;
	// jQuery('#zoom').click(function(){
	// 	if(enabled)
	// 	{
	// 		enabled = false;
	// 		$zoom.destroy();
	// 		jQuery(this).html('<i class="fas fa-search-plus"></i> Enable Zoom');
	// 	}
	// 	else
	// 	{
	// 		enabled = true;
	// 		$zoom.magnify();
	// 		jQuery(this).html('<i class="fas fa-search-minus"></i> Disable Zoom');
	// 	}
	// });

	// Home Carousels
	// jQuery('.home-carousel').owlCarousel({
	// 	loop:false,
	// 	margin:0,
	// 	nav:false,
	// 	dots:true,
	// 	autoplay:true,
	// 	autoplayTimeout:15000,
	// 	responsive:{
	// 		0:{
	// 			items:1
	// 		},
	// 		300:{
	// 			items:1
	// 		},
	// 		600:{
	// 			items:1
	// 		},
	// 		900:{
	// 			items:1
	// 		},
	// 		1200:{
	// 			items:1
	// 		},
	// 		1440:{
	// 			items:1
	// 		}
	// 	}
	// });

	


	// reference for main items
	var singlePropertyCarousel = jQuery('#single-property-carousel');
	// reference for thumbnail items
	var singlePropertyThumbnailCarousel = jQuery('#single-property-carousel-thumbs');
	//transition time in ms
	var duration = 300;

	singlePropertyCarousel.owlCarousel({
		loop:false,
		margin:0,
		nav:false,
		dots:false,
		autoplay:true,
		autoplayTimeout:15000,
		autoHeight:true,
		responsive:{
			0:{
				items:1
			},
			300:{
				items:1
			},
			600:{
				items:1
			},
			900:{
				items:1
			},
			1200:{
				items:1
			},
			1440:{
				items:1
			}
		}
	}).on('changed.owl.carousel', function (e) {
		//On change of main item to trigger thumbnail item
		singlePropertyThumbnailCarousel.trigger('to.owl.carousel', [e.item.index, duration, true]);
		singlePropertyThumbnailCarousel.find('.current').removeClass('current');
		var index = e.item.index;
		var offset = jQuery(e.target).find('.active:first').prevAll('.cloned').length;
		singlePropertyThumbnailCarousel.find('.owl-item').eq(index-offset).addClass('current');
	});

	singlePropertyThumbnailCarousel.owlCarousel({
		loop:false,
		margin:24,
		nav:false,
		dots:false,
		autoplay:false,
		responsive:{
			0:{
				items:2
			},
			300:{
				items:2
			},
			600:{
				items:3
			},
			900:{
				items:4
			},
			1200:{
				items:4
			},
			1440:{
				items:4
			}
		}
	}).on('click', '.owl-item', function () {
		// On click of thumbnail items to trigger same main item
		singlePropertyCarousel.trigger('to.owl.carousel', [jQuery(this).index(), duration, true]);
		singlePropertyThumbnailCarousel.find('.current').removeClass('current');
		jQuery(this).addClass('current');

	}).on('changed.owl.carousel', function (e) {
		// On change of thumbnail item to trigger main item
		singlePropertyCarousel.trigger('to.owl.carousel', [e.item.index, duration, true]);
	});

	singlePropertyThumbnailCarousel.find('.owl-item').first().addClass('current');

	jQuery('#singlePropertyCarouselRight').click(function() {
		singlePropertyCarousel.trigger('next.owl.carousel');
	});
	jQuery('#singlePropertyCarouselLeft').click(function() {
		singlePropertyCarousel.trigger('prev.owl.carousel');
	});

	jQuery('#partner-logos').owlCarousel({
		loop:false,
		margin:30,
		nav:false,
		dots:true,
		autoplay:true,
		autoplayTimeout:15000,
		autoplayHoverPause:true,
		responsive:{
			0:{
				items:1
			},
			640:{
				items:2
			},
			1024:{
				items:3
			},
			1200:{
				items:4
			},
			1440:{
				items:5
			}
		}
	});

	
	
	

	jQuery('#off-canvas').on('opened.zf.offcanvas', function(){
		jQuery('#off-canvas-close').removeClass('slide-right');
		jQuery('#off-canvas-close').addClass('slide-left');
		jQuery('#mobileMenuToggle').removeClass('fadeIn-right');
		jQuery('#mobileMenuToggle').addClass('fadeOut-left');
	});

	jQuery('#off-canvas-close').click(function(){
		jQuery('#off-canvas-close').removeClass('slide-left');
		jQuery('#off-canvas-close').addClass('slide-right');
		jQuery('#mobileMenuToggle').removeClass('fadeOut-left');
		jQuery('#mobileMenuToggle').addClass('fadeIn-right');
		setTimeout(function(){
			jQuery('#off-canvas').foundation('close');
		}, 180);
	});

	jQuery('#off-canvas').on('closed.zf.offcanvas', function(){
		jQuery('#off-canvas-close').removeClass('slide-left');
		jQuery('#off-canvas-close').addClass('slide-right');
		jQuery('#mobileMenuToggle').removeClass('fadeOut-left');
		jQuery('#mobileMenuToggle').addClass('fadeIn-right');
	});

});





/** ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= *
 *  ----------------- THEME FUNCTIONS - START ------------------- *
 *  ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= */
function triggerThemeFunctions()
{
	// REMOVE EMPTY P TAGS CREATED BY WP INSIDE OF ACCORDION AND ORBIT
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// ADD FLEX VIDEO TO YOUTUBE AND VIMEO EMBEDS
	jQuery(':not(.responsive-embed):not(.flex-video)>iframe[src*="youtube.com"], :not(.responsive-embed):not(.flex-video)>iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// ENABLE PSEUDO ELEMENTS FOR FONT AWESOME
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};

	// DISABLE FIRST OPTION
	jQuery('select.disable-first-option').each(function(){
		jQuery(this).find('option').first().attr('disabled', 'disabled');
	});

	// PRINT CURRENT YEAR
	jQuery('.copyright-year').html(new Date().getFullYear());

	// HANDLE DATA-HREF
	window.setHrefs();

	// TRIGGER EQUALIZER
	window.initEqualizeContent(EQUALIZE_CONTENT);

	// INTL-TEL-INPUT
	window.initTelephoneInput(PHONE_FIELD, THEME_FOLDER);

	// ENABLE NEGATIVE MARGINS
	window.enableNegativeMargins();

	// FOUNDATION DATEPICKER
	window.initDatepickerInput(DATEPICKER_FIELD, DATEPICKER_FORMAT);

	// // ENABLE CALLRAIL TRACKING
	// window.enableCallrailTracking();
}
/** ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= *
 *  ------------------ THEME FUNCTIONS - END -------------------- *
 *  ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= */